import Icon from '../components/Icon.vue'

Icon.register({
  crutch: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.3 185.7c2.9 2.9 4.6 6.9 4.6 11.3 0 4.4-1.8 8.4-4.7 11.3l-22.6 22.6c-2.9 2.9-6.9 4.7-11.3 4.7s-8.4-1.8-11.3-4.7l-181-181c-2.9-2.9-4.7-6.9-4.7-11.3s1.8-8.4 4.7-11.3l22.7-22.6c2.9-2.9 6.9-4.7 11.3-4.7 4.4 0 8.4 1.8 11.3 4.7zM327.8 252.1l55.1-55.1 45.3 45.3-109.7 109.7c-12.5 12.5-28.5 21.5-46.3 25.6l-120.3 27.8-102 102c-2.9 2.9-6.9 4.7-11.3 4.7s-8.4-1.8-11.3-4.7l-22.6-22.6c-2.9-2.9-4.7-6.9-4.7-11.3s1.8-8.4 4.7-11.3l102-102 27.7-120.3c4.1-17.8 13.2-33.8 25.7-46.3l109.7-109.7 45.3 45.3-55.1 55.1zM273.2 306.7l9.3-9.3-67.9-67.9-9.3 9.3c-4.2 4.2-7.2 9.5-8.6 15.5l-18.3 79.3 79.3-18.3c5.9-1.4 11.3-4.4 15.5-8.5z'
      }
    ]
  }
})
